import { BlockquoteElement } from '@typedream/components';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_BLOCKQUOTE } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';

export const createBlockquotePlugin = createTElementPluginFactory({
  key: ELEMENT_BLOCKQUOTE,
  component: withDropTarget(BlockquoteElement),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/quote.png',
      title: 'Quote',
      subtitle: 'Emphasize a quote',
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      focusableWhenEmpty: true,
      validProperties: [
        'align',
        'width',
        'width_max',
        'mobile_hide',
        'desktop_hide',
        'connect_data',
      ],
    },
  },
});
